import { Stack, useLocalSearchParams } from "expo-router";
import TrafficFlowScreen from "@src/features/traffic-flow/screens/TrafficFlowScreen.web";

export default function TenantSiteTrafficFlowScreen() {
  const { siteId } = useLocalSearchParams<{ siteId: string }>();
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <TrafficFlowScreen siteIdFromRoute={siteId} />
    </>
  );
}
